import { render, staticRenderFns } from "./EditRentalObject.vue?vue&type=template&id=69e60d8e&"
import script from "./EditRentalObject.vue?vue&type=script&lang=ts&"
export * from "./EditRentalObject.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports